/**
 * @generated SignedSource<<56d375061792a9730ad632862149b7a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetailsTabs_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutModule_user" | "PdpRespDealerDetails_user">;
  readonly " $fragmentType": "PdpRespDetailsTabs_user";
};
export type PdpRespDetailsTabs_user$key = {
  readonly " $data"?: PdpRespDetailsTabs_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetailsTabs_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetailsTabs_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutModule_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3e9e199300fce4013d1fd2aa7513e5df";

export default node;
